export const stockistTexts: Record<string, string> = {
	Stockist: 'Designed to showcase collections of books and stationery with clarity and style.',
	Residence: 'Created to beautifully present home décor and furniture collections with warmth and elegance.',
	Porter: 'Built to effectively present clothing collections with style and sophistication.',
	Verve: 'Made to present beauty and wellness products with harmony and grace.',
	Optic: 'Created to showcase accessories and sunglasses collections with flair and attitude.',
};

export const promptTexts: Record<string, string> = {
	Prompt: 'Clean and modern with a product-focused layout, made for electronics, gadgets, and tech stores.',
	Leap: 'Minimal and content-focused with a clear structure, ideal for books, stationery, and digital collections.',
	Imagine: 'Playful and energetic with vibrant visuals, designed for toy shops, games, and creative playsets.',
	Well: 'Elegant and refined with rich imagery, created for skincare, wellness, and beauty brands.',
	Rapid: 'Bold and tech-inspired with a sharp layout, built for auto parts, accessories, and detailing stores.',
};
